const lendingClubPalette = {
  // custom
  sapphire: {
    50: '#eaf4f9',
    100: '#d0e9f5',
    300: '#58b0dd',
    500: '#0077b3',
    700: '#004f87',
    900: '#00355c',
  },

  denim: {
    50: '#edf3f7',
    100: '#b4c7d9',
    300: '#557494',
    500: '#113b5e',
  },

  cardinal: {
    50: '#fcf4f2',
    100: '#f7ded9',
    300: '#e97765',
    500: '#d42c0e',
    700: '#c7270c',
    900: '#93220f',
  },

  sky: {
    50: '#f0f8fa',
    100: '#d0ecf5',
    300: '#a8dced',
    500: '#82cde5',
    700: '#528899',
    900: '#345a66',
  },

  stainless: {
    500: '#c8cfd4',
    700: '#6c7275',
    900: '#4c5153',
  },

  neutral: {
    spoon: '#95a1a6',
    fog: '#99b1bf',
    mono: '#cbd2d5',
    narwhal: '#557b92',
    stainless: '#c8cfd4',
    iceberg: '#f6f9f9',
  },
  whites: {
    snow: '#fefefe',
    snow2: '#fafafa',
    snow3: '#f5f5f5',
    snow4: '#fefefe',
    marble: '#f7f7f7',
  },
  pearlLusta: {
    500: '#fcf3dc',
  },
  gallery: {
    500: '#ececec',
  },
  cadetBlue: {
    500: '#a8bac8',
  },
  avocado: {
    500: '#e1e676',
  },
  black: {
    '000': '#000000',
  },
};

const mobilePalette = {
  primary: lendingClubPalette.denim[500],
  secondary: '#ea4224',
  secondaryAccessible: '#006553',
  tertiary: '#007cbc',
  background: '#f9f9f9',
  active: lendingClubPalette.denim[500],
  successGreen: '#1d994b',
  warningYellow: '#eeb41e',
  text: lendingClubPalette.denim[500],
  loginActive: '#df3516',
  introductionBackground: '#ea4324',
  introduction1UpperFill: lendingClubPalette.denim[500],
  introduction1InnerFill: '#7ac3db',
  introduction2Fill: '#7ac3db',
  introduction3Fill: '#7ac3db',
  textBlack: '#333333',
  gray: '#d2d6db',
  chevronGray: '#949494',
  separatorGray: '#e8e8e8',
  transparent: '#ffffff00',
  lightGray: '#f6f6f6',
  iconGray: '#8c8c8c',
  mediumGray: '#e8e8e8',
  darkGray: '#4c4c4c',
  dark: '#4c4c4c',
  light: '#ffffff',
  lightBackground: '#f6f6f6',
  red: '#801d14',
  errorRed: '#d93b3b',
  ignoreContrast: '#604a15',
  lightGreen: '#b2d59f',
  lightBlue: '#6eafef',
  error: '#a30000',
  errorUnderlay: '#dc0000',
};

module.exports = {
  lendingClubPalette,
  mobilePalette,
};

